import { forwardRef } from "react";

import type { PlanSet } from "@btnet/services-btnet/handlers/models/planSet";

import { BdsIconCaretLargeRight } from "@buildertrend/components";

import { displayWithFriendlyDefault } from "utilities/helpers";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { DragAndDropHandle } from "commonComponents/utilities/DragAndDrop/DragAndDrop";
import { TextTruncate } from "commonComponents/utilities/TextTruncate/TextTruncate";

import "./PlanSetsItem.less";

interface IPlansSetItemProps {
    planSet: PlanSet;
    isSelected: boolean;
    onClick: (planSet: PlanSet) => void;
    isDragEnabled?: boolean;
    useMobileLayout?: boolean;
}

export const PlanSetsItem = forwardRef<HTMLDivElement, IPlansSetItemProps>(function PlanSetsItem(
    { planSet, isSelected, onClick, isDragEnabled, useMobileLayout = false },
    ref,
) {
    const handleClick = () => {
        onClick(planSet);
    };

    return (
        <div ref={ref} className="plans-set-item-wrapper">
            <BTButton
                type="tertiary"
                className={`plans-set-item bt-flat max-w-none! [&>span]:flex-1! ${
                    isSelected ? "selected" : ""
                }`}
                onClick={handleClick}
                data-testid={`plans-set-item-${planSet.setId}`}
            >
                <BTRow className="set-item-header" justify="space-between" align="middle">
                    <div className="set-item-title">
                        <TextTruncate>{displayWithFriendlyDefault(planSet.name)}</TextTruncate>
                    </div>
                    <BdsIconCaretLargeRight className="set-item-arrow" />
                </BTRow>
            </BTButton>
            {isDragEnabled && !useMobileLayout && (
                <span
                    className="plans-set-item-drag-handle"
                    data-testid={`plans-set-item-drag-handle-${planSet.setId}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <DragAndDropHandle />
                </span>
            )}
        </div>
    );
});
